import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-microsoft-callback',
    template: '<p>Procesando autenticación de Microsoft...</p>',
    standalone: false
})
export class MicrosoftCallbackComponent implements OnInit {
    constructor(private route: ActivatedRoute, private http: HttpClient) {}

    ngOnInit() {
        const code = this.route.snapshot.queryParamMap.get('code');
        if (!code) {
            this.postToOpener({ type: 'MICROSOFT_OAUTH_ERROR', error: 'No code received' });
            return;
        }

        const redirectUri = window.location.origin + '/microsoft-callback';

        this.http.post(`${environment.apiUrl}/common/auth/microsoft-exchange`, { code, redirect_uri: redirectUri })
            .subscribe({
                next: (resp: any) => {
                    const data = resp.result || resp;
                    this.postToOpener({
                        type: 'MICROSOFT_OAUTH_SUCCESS',
                        provider_id: data.provider_id,
                        email: data.email,
                        name: data.name
                    });
                },
                error: () => {
                    this.postToOpener({ type: 'MICROSOFT_OAUTH_ERROR', error: 'Exchange failed' });
                }
            });
    }

    private postToOpener(data: any) {
        if (window.opener) {
            window.opener.postMessage(data, window.location.origin);
            setTimeout(() => window.close(), 500);
        }
    }
}
